import { render, staticRenderFns } from "./GameDetail_box2.vue?vue&type=template&id=6348895b"
import script from "./GameDetail_box2.vue?vue&type=script&lang=js"
export * from "./GameDetail_box2.vue?vue&type=script&lang=js"
import style0 from "./GameDetail_box2.vue?vue&type=style&index=0&id=6348895b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports